// resultado da importacao
export enum ResultadoApontamentosImportacaoEnum {
	PROCESSANDO = -1,
    SUCESSO,
    PARCIAL,
    ERRO,
    EXCLUIDO,
    EXCLUIDO_PARCIALMENTE
}
